// utils/project-dir.ts
// Centralised project-directory resolution used by all plugin entry points.

/**
 * Resolve the skaile project directory from environment variables.
 *
 * Resolution order:
 * 1. `SKAILE_PROJECT_DIR` (always checked first)
 * 2. Any additional env var keys supplied by the caller (in order)
 * 3. `process.cwd()` as final fallback
 *
 * @param additionalEnvVars - Optional list of extra environment variable names
 *   to check before falling back to `process.cwd()`.
 * @returns Absolute path to the resolved project directory.
 *
 * @example
 * // Claude Code — also checks CLAUDE_PROJECT_DIR
 * const projectDir = resolveProjectDir(["CLAUDE_PROJECT_DIR"]);
 *
 * // OMP / standalone — SKAILE_PROJECT_DIR or cwd only
 * const projectDir = resolveProjectDir();
 *
 * @docLink packages/workspace-plugin/concepts#workspaceplugin-lifecycle
 */
export function resolveProjectDir(additionalEnvVars?: string[]): string {
  if (process.env.SKAILE_PROJECT_DIR) return process.env.SKAILE_PROJECT_DIR;
  for (const key of additionalEnvVars ?? []) {
    const val = process.env[key];
    if (val) return val;
  }
  return process.cwd();
}
